import { graphql } from 'gql';

export const uerWorkOrderChangeUersSelectionListGql = graphql(`
    query uerWorkOrderChangeUersSelectionList(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $chapter: ChapterEnum!
        $objectIds: [WorkOrderChangeObjectIdInput!]!
        $where: WorkOrderChangeUerItemDataFilterInput
        $order: [WorkOrderChangeUerItemDataSortInput!]
    ) {
        uerWorkOrderChangeUersSelectionList(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            chapter: $chapter
            objectIds: $objectIds
            where: $where
            order: $order
        ) {
            totalCount
            items {
                id
                sectionId
                sectionName
                groupId
                groupName
                groupFullName
                code
                name
                unit
                unitCost
                chapter
                status
                justification
            }
        }
    }
`);

export const uerAddUersToWorkOrderChangeObjectsGql = graphql(`
    mutation uerAddUersToWorkOrderChangeObjects(
        $workOrderChangeId: Long!
        $workOrderChangeObjectIds: [WorkOrderChangeObjectIdInput!]!
        $uerInputs: [PriceListUerRowInput!]!
        $constructionTypeId: Int!
        $chapter: ChapterEnum!
    ) {
        uerAddUersToWorkOrderChangeObjects(
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectIds: $workOrderChangeObjectIds
            uerInputs: $uerInputs
            constructionTypeId: $constructionTypeId
            chapter: $chapter
        ) {
            data
            result
            message
            validation {
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const uerWorkOrderChangeUsersSelectionListSectionFilter = graphql(`
    query uerWorkOrderChangeUsersSelectionListSectionFilter(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $objectIds: [WorkOrderChangeObjectIdInput!]!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerWorkOrderChangeUsersSelectionListSectionFilter(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            objectIds: $objectIds
            chapter: $chapter
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderChangeUsersSelectionListCodeFilter = graphql(`
    query uerWorkOrderChangeUsersSelectionListCodeFilter(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $objectIds: [WorkOrderChangeObjectIdInput!]!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerWorkOrderChangeUsersSelectionListCodeFilter(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            objectIds: $objectIds
            chapter: $chapter
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderChangeUsersSelectionListGroupFilter = graphql(`
    query uerWorkOrderChangeUsersSelectionListGroupFilter(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $objectIds: [WorkOrderChangeObjectIdInput!]!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerWorkOrderChangeUsersSelectionListGroupFilter(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            objectIds: $objectIds
            chapter: $chapter
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderChangeUsersSelectionListNameFilter = graphql(`
    query uerWorkOrderChangeUsersSelectionListNameFilter(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $objectIds: [WorkOrderChangeObjectIdInput!]!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerWorkOrderChangeUsersSelectionListNameFilter(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            objectIds: $objectIds
            chapter: $chapter
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
